import { Droplist } from '@snack-uikit/list';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { sparkgatewayV1 } from '../../../../../../services';
import { FormField } from '../../../../../../types/backendContent/RegistryForm';
import { debounce } from '../../../../../../utils/debounce';
import { Input } from '../../../Input';
import { getItemsDropList } from './utils/getItemsDropList';
import { getValidationInputType } from './utils/getValidationInputType';
import { sparkDataToItemDropList } from './utils/sparkDataToItemDropList';
import {
  DropListItemSpark,
  FieldTypeInnCompany,
  ResponseSparkData,
} from './utils/types';

export type SparkFieldProps = Pick<FormField, 'required'> & {
  className?: string;
  classNameInput?: string;
  disabled?: boolean;
  label: string;
  type: FieldTypeInnCompany;
  additionalType: FieldTypeInnCompany;
  sendFormFillAnalytics(name: string): void;
};

const fetchSpark = async (searchStr: string) => {
  return sparkgatewayV1
    .get<{ data: Array<ResponseSparkData> }>({
      url: `search?query=${searchStr}`,
    })
    .then(({ data: response }) => {
      if (!response.data) throw new Error(`fetcher`);
      return response.data;
    });
};

export function SparkField(props: SparkFieldProps) {
  const {
    className,
    classNameInput,
    label,
    type,
    additionalType,
    required = false,
    disabled,
    sendFormFillAnalytics,
  } = props;
  const [selectedId, setSelectedId] = useState<string>();
  const [sparkLoading, setSparkLoading] = useState(false);
  const [items, setItems] = useState<Array<DropListItemSpark>>();

  const { setValue, getValues } = useFormContext();

  const fetchData = (valueSearch: string) => {
    fetchSpark(valueSearch).then((data: Array<ResponseSparkData>) => {
      setSparkLoading(false);
      setItems(data.map(sparkDataToItemDropList));
    });
  };

  const handleChangeInputInn = (value: string) => {
    if (value.length > 0) {
      setSelectedId(undefined);
      setSparkLoading(true);
      fetchData(value);
    } else {
      setItems(undefined);
    }
  };

  const onSelect = (itemId: string) => {
    setSelectedId(itemId);
    if (items) {
      const typeValue = items.find((item) => item.id === itemId)?.[type] ?? '';
      setValue(type, typeValue, {
        shouldValidate: true,
      });
      if (Object.hasOwn(getValues(), additionalType)) {
        const additionalValue =
          items.find((item) => item.id === itemId)?.[additionalType] ?? '';
        setValue(additionalType, additionalValue, {
          shouldValidate: true,
        });
      }
    }
  };

  return (
    <div className={className}>
      <Droplist
        widthStrategy="eq"
        selection={{
          value: selectedId,
          onChange: onSelect,
          mode: 'single',
        }}
        scroll={true}
        loading={sparkLoading}
        trigger="focus"
        items={getItemsDropList(sparkLoading, items)}
        closeDroplistOnItemClick
      >
        <Input
          {...getValidationInputType(type)}
          className={classNameInput}
          name={type}
          label={label}
          onChange={debounce(handleChangeInputInn, 500)}
          required={required}
          disabled={disabled}
          data-qa="section_input"
          onBlur={(event) => {
            if (event.currentTarget.value) {
              sendFormFillAnalytics(label);
            }
          }}
        />
      </Droplist>
    </div>
  );
}
